export default "__VITE_ASSET__B44ygmRD__"